import { User } from '../../app/store/types/auth.types';

export const validateUserRole = (user: User | null, roles?: string[]): boolean => {
  if (!roles?.length) return true;
  return user?.roles?.some(role => roles.includes(role)) ?? false;
};
